// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../devices/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../devices/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".full-width-and-height[data-v-390a404e]{height:100%;width:100%}img[data-v-390a404e]{width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
